import React, { useEffect } from 'react';

import CompanyForm from 'components/forms/CompanyForm';
import { updateTitle } from 'helpers/common';
import MainContent from 'components/MainContent';

const CompanyEditScreen = () => {
  useEffect(() => {
    updateTitle('Edit Company');
  }, []);

  return (
    <MainContent type="form">
      <CompanyForm />
    </MainContent>
  );
};

export default CompanyEditScreen;
